const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/settingsReducer.ts';
import Immutable from 'immutable';
import {
    emptyAppSettings,
    emptyUserSettings,
    SET_APP_SETTING,
    SET_APP_SETTINGS,
    SET_USER_SETTING,
    SET_USER_SETTINGS,
} from '../defs/settings';

export const settingsReducerInitialState: any = Immutable.fromJS({
    app: Immutable.fromJS(emptyAppSettings),
    user: Immutable.fromJS(emptyUserSettings),
});

/**
 * Reduces an action containing screen size and
 * determines type and orientation of the device.
 * Currently based on css width/height, which is
 * resolution-independent due to the viewport definition in index.html.
 *
 * @param state
 * @param action
 * @returns {any}
 */
export function settingsReducer(state = settingsReducerInitialState, action: any = {}) {
    switch (action.type) {
        case SET_APP_SETTINGS:
            return state.mergeIn(['app'], action.payload);
        case SET_APP_SETTING:
            return state.setIn(['app', action.payload.key], action.payload.value);
        case SET_USER_SETTINGS:
            return state.mergeIn(['user'], action.payload);
        case SET_USER_SETTING:
            return state.setIn(['user', action.payload.key], action.payload.value);
        default:
            return state;
    }
}

export default settingsReducer;
